export const CHECK_INTERVAL = 2;
export const REMOTE_CONTROL_INTERVAL = 10;


// WEBPACK FOOTER //
// ./src/constants/timers.js